import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';

import ItineraryEdit from './ItineraryEdit';
import ItineraryList from './ItineraryList';

const ItineraryPage = (props) => {
    let { path } = useRouteMatch();
    const [lastURLParams, setLastURLParams] = React.useState(new URLSearchParams(window.location.search));

    return (
        <Switch>
            <Route path={`${path}/:id/preview`}>
                <ItineraryList setLastURLParams={setLastURLParams} {...props} />
            </Route>
            <Route path={`${path}/:id/:tab/:imageid`}>
                <ItineraryEdit lastURLParams={lastURLParams} {...props} />
            </Route>
            <Route path={`${path}/:id/:tab`}>
                <ItineraryEdit lastURLParams={lastURLParams} {...props} />
            </Route>
            <Route path={`${path}/:id`}>
                <ItineraryEdit lastURLParams={lastURLParams} {...props} />
            </Route>
            <Route exact path={path}>
                <ItineraryList setLastURLParams={setLastURLParams} {...props} />
            </Route>
        </Switch>
    );
};

export default ItineraryPage;
